import React from "react";
//

import Typography from "@mui/material/Typography";
import EmailIcon from "@mui/icons-material/MailOutline";
import makeStyles from "@mui/styles/makeStyles";
//
import { useTranslation } from "@limitless/common/hooks";

const useStyles = makeStyles(() => ({
    labelContainer: {
        display: "flex",
        marginBottom: 8
    }
}));

const ClientSecureEmailLabel = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={classes.labelContainer}>
            <div style={{ marginRight: 8 }}>
                <EmailIcon />
            </div>
            <div>
                <Typography color="textPrimary" variant="caption">
                    {t(
                        "If an expert is not available right away, you will receive a response via the email associated to your account"
                    )}
                </Typography>
            </div>
        </div>
    );
};

export default ClientSecureEmailLabel;
